import style from "./ProfileBanner.module.css";
import { useGetUserByUsername } from "../../hooks/useGetUserByUsername";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Container from "@/layouts/container/Container";

import Icon from "@/ui/icon/Icon";
import Badge from "@/ui/badge/Badge";
import Error from "@/ui/error/Error";

import ProfileTabs from "../profileTabs/ProfileTabs";
import { useUser } from "../../hooks/useUser";

import { formatLongDate } from "@/i18n/format";
import { useCurrentLanguage } from "@/i18n/useLocalized";
import UserActivity from "@/features/activityStreak/components/userActivity/UserActivity";

function ProfileBanner({ username }) {
	const { t } = useTranslation();
	const { user, isPending, isError } = useGetUserByUsername(username);
	const { user: owner, isPending: ownerIsPending } = useUser();
	const language = useCurrentLanguage();

	if (isError) {
		return (
			<Container>
				<Error />
			</Container>
		);
	}

	return (
		<div
			className={`${style.profileBanner} ${
				isPending && ownerIsPending ? style.skeleton : ""
			}`}
		>
			<Container>
				<div className={style.container}>
					<div className={style.header}>
						<Container>
							<div className={style.decoration}>
								<span></span>
								<span></span>
								<span></span>
							</div>
						</Container>
					</div>

					<div className={style.userInfoBar}>
						<div className={style.userMainInfo}>
							<div className={style.imgHolder}>
								<img
									src={user?.safe_picture_url}
									alt={
										!isPending && !ownerIsPending
											? t("auth:profile.avatarAlt", {
													username: user?.username,
												})
											: ""
									}
								/>
							</div>
							<div className={style.userDetails}>
								<h2 className={style.fullName}>
									{user?.first_name} {user?.last_name}
								</h2>
								<div className={style.itemsHolder}>
									<div className={style.username}>
										@{user?.username}
									</div>
									<span className={style.separator}></span>
									<div className={style.joinedDate}>
										<Icon icon="fa-calendar" />
										<span>
											{formatLongDate(user?.date_joined, language)}
										</span>
									</div>
								</div>
								{user?.is_subscribed && <Badge />}
							</div>
						</div>
						<div className={style.activityHolder}>
							<UserActivity username={username} />
						</div>
						<div className={style.tabsHolder}>
							<ProfileTabs username={username} />
						</div>
						<div className={style.moreHolder}>
							{owner?.username === username && (
								<Link to="/settings" className={style.btn}>
									<Icon icon="fa-gear" />
								</Link>
							)}
						</div>
					</div>
				</div>
			</Container>
		</div>
	);
}

export default ProfileBanner;
